{
    "firebase": {
        "apiKey": "AIzaSyC8tivPreytHdsXxrppU-fnlH2fpmb8Pio",
        "authDomain": "flightline-demo-dev.firebaseapp.com",
        "databaseURL": "https://flightline-demo-dev-default-rtdb.firebaseio.com",
        "projectId": "flightline-demo-dev",
        "storageBucket": "flightline-demo-dev.firebasestorage.app",
        "messagingSenderId": "321215760873",
        "appId": "1:321215760873:web:0785adbdf7b1f9eb85e378"
    },
    "clientName": "Demo",
    "pdfViewerKey": "b6e99a26b87f41d8b9b559f10c557346",
    "domains": ["flightline-demo-dev.web.app"]
}
